// src/services/api.js – Centralized network abstraction for all backend calls

const BASE = '';

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options
  });
  const text = await res.text();
  let data;
  try {
    data = JSON.parse(text);
  } catch {
    data = { error: text };
  }
  if (!res.ok) {
    throw new Error(data?.error || `HTTP ${res.status}`);
  }
  return data;
}

// ─── Recipes ────────────────────────────────────────────────────────────────

export const recipesApi = {
  list: () =>
    request('/.netlify/functions/recipes'),

  get: (id) =>
    request(`/.netlify/functions/recipes?id=${id}`),

  create: (recipe) =>
    request('/.netlify/functions/recipes', {
      method: 'POST',
      body: JSON.stringify(recipe)
    }),

  update: (id, recipe) =>
    request(`/.netlify/functions/recipes?id=${id}`, {
      method: 'PUT',
      body: JSON.stringify(recipe)
    }),

  remove: (id) =>
    request(`/.netlify/functions/recipes?id=${id}`, { method: 'DELETE' })
};

// ─── Pantry ─────────────────────────────────────────────────────────────────

export const pantryApi = {
  list: () =>
    request('/.netlify/functions/pantry'),

  get: (id) =>
    request(`/.netlify/functions/pantry?id=${id}`),

  create: (item) =>
    request('/.netlify/functions/pantry', {
      method: 'POST',
      body: JSON.stringify(item)
    }),

  update: (id, item) =>
    request(`/.netlify/functions/pantry?id=${id}`, {
      method: 'PUT',
      body: JSON.stringify(item)
    }),

  remove: (id) =>
    request(`/.netlify/functions/pantry?id=${id}`, { method: 'DELETE' })
};

// ─── AI Recipe Suggestions ───────────────────────────────────────────────────

export const suggestApi = {
  fromPantry: () =>
    request('/.netlify/functions/suggest-recipes', { method: 'POST', body: '{}' }),

  airfryerRoasting: () =>
    request('/.netlify/functions/suggest-recipes', {
      method: 'POST',
      body: JSON.stringify({ mode: 'airfryer_roasting' })
    })
};

// ─── Appliance Conversion ────────────────────────────────────────────────────

export const convertApi = {
  toAppliance: (recipeId, targetAppliance, optimizeCG = false) =>
    request('/.netlify/functions/recipe-convert', {
      method: 'POST',
      body: JSON.stringify({ recipeId, targetAppliance, optimizeCG })
    })
};
